const sectionNavigation = {
  performance: {
    label: 'Performance',
    description: 'Understand recurring revenue, profitability and whether the underlying calculations are trustworthy.',
    links: [
      { key: 'metrics', label: 'Revenue metrics', href: '#/commercial-metrics' },
      { key: 'profitability', label: 'Profitability', href: '#/commercial-profitability' },
      { key: 'calculations', label: 'Calculation checks', href: '#/commercial-calculations' },
    ],
  },
};

const dataSetupNavigation = {
  label: 'Data setup',
  description: 'Choose bulk import for prepared files or guided entry for one-off records.',
  links: [
    { key: 'imports', label: 'Data imports', href: '#/commercial-imports' },
    { key: 'entry', label: 'Manual entry', href: '#/commercial-entry' },
  ],
};

const workflowSetupNavigation = {
  label: 'Workflow setup',
  description: 'Control how customer workflows start and which approved message they send.',
  links: [
    { key: 'automation', label: 'Workflow modes', href: '#/commercial-automation' },
    { key: 'templates', label: 'Email templates', href: '#/commercial-email-templates' },
  ],
};

const operationalRecordsNavigation = {
  label: 'Operational records',
  description: 'Inspect workflow outcomes separately from the audit record of commercial changes.',
  links: [
    { key: 'history', label: 'Workflow history', href: '#/commercial-workflow-history' },
    { key: 'audit', label: 'Audit trail', href: '#/commercial-audit' },
  ],
};

const operationsNavigation = {
  label: 'Operations',
  description: 'Set up commercial data and workflows, then inspect exactly what ran and what changed.',
  groups: [dataSetupNavigation, workflowSetupNavigation, operationalRecordsNavigation],
  links: [
    ...dataSetupNavigation.links,
    ...workflowSetupNavigation.links,
    ...operationalRecordsNavigation.links,
  ],
};

export const getCommercialSectionNavigation = area => {
  if (area === 'operations') return operationsNavigation;
  return sectionNavigation[area] || null;
};

export const buildOverviewQueues = (attention = {}, latestMonth) => [
  {
    key: 'overdue',
    tone: 'danger',
    title: `${Number(attention.overdueRenewals) || 0} overdue renewals`,
    amount: Number(attention.overdueArr) || 0,
    description: 'ARR needs follow-up',
    action: 'Review overdue agreements',
    href: '#/commercial-renewals?view=overdue',
  },
  {
    key: 'upcoming',
    tone: 'warning',
    title: `${Number(attention.renewalsWithin90Days) || 0} renew within 90 days`,
    amount: Number(attention.arrWithin90Days) || 0,
    description: 'ARR approaching renewal',
    action: 'Plan upcoming renewals',
    href: '#/commercial-renewals?view=upcoming',
  },
  {
    key: 'signals',
    tone: Number(attention.contractionSignals) ? 'danger' : 'positive',
    title: `${Number(attention.contractionSignals) || 0} negative signals`,
    description: `Contractions or churn${latestMonth ? ` in ${latestMonth}` : ''}`,
    action: 'Review affected customers',
    href: '#/commercial-customers?signal=negative',
  },
];
